import { useObservaOptional } from "@morganisbatman/observa-client-react";
import { useMemo } from "react";

import { appEvents } from "./taxonomy";

// Typed observa client for the app — event() is constrained to the aucashapp
// taxonomy (event types + payload shapes are TS-checked). Returns null when no
// ObservaProvider is mounted: _layout.tsx renders without the provider when
// OBSERVA_PUBLIC_KEY is unset (local dev) and the test renderer has none, so
// callers guard with `observa?.event(...)` and emits are simply skipped there.
export function useAppObserva() {
  const client = useObservaOptional();
  return useMemo(() => (client ? appEvents.wrap(client) : null), [client]);
}
